import React from "react";

import { Navigate } from "react-router-dom";

import { useCaseInsightsAccess } from "src/cases/analytics/useCaseInsightsAccess";
import { DashboardPageParams, getUrlToCaseQueuePage } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type Props = {
  children: React.ReactNode;
};

// A direct URL to case analytics bypasses the (hidden) nav item, so send
// visitors without access back to the case queues page.
export const CaseAnalyticsRouteGuard: React.FC<Props> = ({ children }) => {
  const { canAccess, isLoading } = useCaseInsightsAccess();
  const { orgId, wsId } = useParamsDecode<DashboardPageParams>();

  if (isLoading) {
    return null;
  }

  if (canAccess) {
    return <>{children}</>;
  }

  return <Navigate replace to={getUrlToCaseQueuePage({ orgId, wsId })} />;
};
